/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';

/**
 * 
 * @export
 * @interface CreateDocumentForLead201Response
 */
export interface CreateDocumentForLead201Response {
    /**
     * 
     */
    data?: Document;
}

/**
 * Check if a given object implements the CreateDocumentForLead201Response interface.
 */
export function instanceOfCreateDocumentForLead201Response(value: object): value is CreateDocumentForLead201Response {
    return true;
}

export function CreateDocumentForLead201ResponseFromJSON(json: any): CreateDocumentForLead201Response {
    return CreateDocumentForLead201ResponseFromJSONTyped(json, false);
}

export function CreateDocumentForLead201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentForLead201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : DocumentFromJSON(json['data']),
    };
}

export function CreateDocumentForLead201ResponseToJSON(json: any): CreateDocumentForLead201Response {
    return CreateDocumentForLead201ResponseToJSONTyped(json, false);
}

export function CreateDocumentForLead201ResponseToJSONTyped(value?: CreateDocumentForLead201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DocumentToJSON(value['data']),
    };
}

